import { useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Prime React Components
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

//Custom Validation
import { OTPValidate } from '../../config/Validate';

//API Constant Settings
import { OTPVERIFICATION } from '../../config/ApiConstant';
import axiosInstance from '../../config/axiosInstance';

interface finalObj {
    mobile: any;
    otp: any;
}

export const OTP = () => {
    document.title = 'OTP Verification | GSPC';

    const { mobile }: any = useParams();
    const [otpNum, setOtpNum] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const toast = useRef<any>(null);

    const navigate = useNavigate();

    //on submit button event
    const onSubmit = async () => {
        try {
            const { errors, isError } = OTPValidate(otpNum);
            setErrors(errors);

            if (!isError) {
                setButtonLoading(true);

                //Create Request Data Object
                const Obj: finalObj = {
                    otp: otpNum,
                    mobile: atob(mobile)
                    // password: atob(password)
                };

                //API Call
                const response = await axiosInstance.post(OTPVERIFICATION, Obj);

                //Get API Response
                if (response) {
                    // get Data for localstorage
                    const { token } = response.data;

                    //Set Token in Localstorage
                    if (token) {
                        //After Success Login Set Token in Common
                        axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + token;

                        //Token Decode
                        const myUserObject = response.data.data;


                        // Permission Data
                        const permissions = myUserObject?.rolemaster?.permissions?.permissions;

                        // sessionStorage.setItem('assigned_menu', myUserObject.assigned_menu);
                        // sessionStorage.setItem('assigned_actions', myUserObject.assigned_actions);

                        //Set Localstorage
                        localStorage.setItem('assigned_menu', myUserObject.assigned_menu);
                        localStorage.setItem('assigned_actions', myUserObject.assigned_actions);
                        localStorage.setItem('user', myUserObject?.id);
                        localStorage.setItem('token', token);
                        localStorage.setItem('name', myUserObject?.full_name);
                        localStorage.setItem('email', myUserObject?.email);
                        localStorage.setItem('permissions', permissions);
                        localStorage.setItem('role', myUserObject.user_type);
                    }

                    toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Login Successful' });

                    setButtonLoading(false);
                    navigate('/dashboard');
                }
            }
        } catch (error: any) {
            setButtonLoading(false);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: error.response.data.error });
        }
    };

    return (
        <div className="login-body">
            <div className="login-panel p-fluid">
                <Toast ref={toast} />
                <div>
                    <div className="logo-container">
                        <img src="/assets/images/gspc_new_logo.jpg" className="login-logo" alt="login-logo" />
                    </div>

                    <div className="mt-5">
                        <h5>OTP Verification</h5>
                        <div className="field">
                            <InputText
                                value={!window.cn(otpNum) ? otpNum : ''}
                                keyfilter={'num'}
                                name="otpNum"
                                autoComplete="off"
                                placeholder="Enter OTP"
                                onChange={(e) => setOtpNum(e.target.value)}
                                className={errors['otpNum'] && 'p-invalid'}
                                maxLength={4}
                                minLength={4}
                            />
                            <small className="p-invalid-txt d-flex">{errors['otpNum']}</small>
                        </div>

                        <div className="button-container">
                            <Button type="button" label="Login" loading={buttonLoading} onClick={onSubmit}></Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
